import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { BehaviorSubject, Observable, of } from 'rxjs';

import { ValidationErrors, ReactiveFormsModule } from '@angular/forms';
import { omit } from 'lodash-es';
import { FormTagListStyle, FormTagListStyling } from '../../../entities/form-tag-list-style.entity';
import { FormValue } from '../../../entities/form-value.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { FormTagListActionItem } from './form-tag-list-action-item.class';
import { ShFormTagListBaseComponent } from '../base-simple/form-tag-list-base.component';
import { ShFormTagListComplexBaseComponent } from '../base-complex/form-tag-list-complex-base.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

type SanitizeToStringFunction = (value: string, existingValues: string[]) => string;
type SanitizeToStringArrayFunction = (value: string, existingValues: string[]) => string[];

@Component({
    selector: 'sh-form-tag-list',
    templateUrl: './form-tag-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, NgIf, ShFormTagListComplexBaseComponent, ReactiveFormsModule, ShFormTagListBaseComponent, AsyncPipe]
})
export class ShFormTagListComponent extends ShBaseFormComponent implements OnInit, OnDestroy {
    public internalError$: BehaviorSubject<string> = new BehaviorSubject('');

    @Output() duplicateValues: EventEmitter<FormValue<string>[]> = new EventEmitter<FormValue<string>[]>();

    @Input() placeholder?: string;
    @Input() duplicateErrorMsg!: string;
    @Input() styling: FormTagListStyling = { style: FormTagListStyle.Default, modifiers: [] };
    @Input() actionItem?: FormTagListActionItem;
    @Input() autocomplete = 'off';
    @Input() singleTag = false;
    @Input() caseSensitive = true;
    @Input() maxLength?: number;

    @Input() sanitizeFct: SanitizeToStringFunction | SanitizeToStringArrayFunction = (value: string) => value;
    @Input() autocompleteFct: (term: string) => Observable<string[]> = term => of([]);

    public emitDuplicates(duplicates: FormValue<string>[]): void {
        this.duplicateValues.emit(duplicates);
    }

    public onInternalError(error: string): void {
        this.internalError$.next(error);
        if (error) {
            this.control.setErrors({ ...this.control.errors, internal: '' });
        } else {
            const newErrors: ValidationErrors = omit(this.control.errors, 'internal');
            this.control.setErrors(Object.keys(newErrors).length > 0 ? newErrors : null);
        }
    }

    public ngOnDestroy(): void {
        this.internalError$.complete();
        super.ngOnDestroy();
    }
}
